<template>

    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header>
                <h4 class="cooperation__expansion-title">Порядок действий</h4>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <ol class="cooperation__expansion-list">
                    <li class="cooperation__expansion-item">Регистрация на платформе <a href="https://ul.su/"
                                                                                        target="_blank">https://ul.su/</a>
                    </li>
                    <li class="cooperation__expansion-item">Поиск нашей организации ООО "Упаковка и Сервис" и ООО "Нова
                        Ролл-стрейч" (входят в группу компаний Novaroll)
                    </li>
                    <li class="cooperation__expansion-item">Внимательное изучение требований для поставщиков услуг</li>
                    <li class="cooperation__expansion-item">Предоставление обязательного пакета документов</li>
                    <li class="cooperation__expansion-item">Готовность работать по нашему договору транспортной
                        экспедиции
                    </li>
                    <li class="cooperation__expansion-item">Подача заявки на аккредитацию</li>
                    <li class="cooperation__expansion-item">Ожидание результата проверки документов</li>
                </ol>
                <p class="cooperation__expansion-desc">О результатах аккредитации Вам будет известно в личном кабинете
                    на платформе «Умная Логистика».</p>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: "expansionPanel",
}
</script>

<style lang="scss">

.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panels {
  margin-top: -17px;
  margin-left: 10px;
}

.v-expansion-panel-header {
  width: 243px;
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 41px;
  height: 55px;
}

.mdi-chevron-down::before {
  content: '';
  width: 12px;
  height: 7px;
  background: url("/local/templates/international/img/svg/expansion-arrow.svg") no-repeat;
  transform: rotate(-180deg) translateY(2px);
}

.v-expansion-panel--active > .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
  transform: rotate(-180deg) translateY(4px);
}
</style>

<style lang="scss" scoped>
.cooperation {
  &__expansion-title {
    font-family: 'RobotoRegular';
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    color: #F94237;
    margin-right: 10px;
  }

  &__expansion-list {
    padding: 16px 20px 16px 36px;
    background: #F4F4F4;
    border-radius: 24px;
  }

  &__expansion-item {
    font-family: 'RobotoRegular';
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;

    & > a {
      font-family: 'RobotoRegular';
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      text-align: left;
      text-decoration-line: underline;
      color: #F94237 !important;
    }
  }

  &__expansion-desc {
    font-family: 'RobotoRegular';
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    color: #282828;
  }
}
</style>